<template>
    <div class="" style="max-width: 100%;">
        <s-crud title="Infracciones de Tránsito" :filter="filter" searchInput height="450" :config="config" add edit
            remove @rowSelected="rowSelected($event)" @addEvent="cleanFields()" @save="save($event)"
            ref="crudtrafficviolations">

            <template v-slot:filter>
                <v-container fluid class="mb-3">
                    <v-row dense>
                        <v-col lg="2" md="3" cols="12">
                            <s-date v-model="filter.ViolationDate" label="Fecha Infracción" clearable noDefault />
                        </v-col>
                        <v-col lg="2" md="3" cols="12">
                            <s-date v-model="filter.ViolationHasta" label="Fecha Hasta" clearable noDefault />
                        </v-col>
                        <v-col lg="2" md="3" cols="12">
                            <s-select-definition :def="1602" label="Tipo" v-model="filter.ViolationType" clearable
                                noDefault />
                        </v-col>
                        <v-col lg="2" md="3" cols="12">
                            <s-select-definition :def="1600" label="Nivel" v-model="filter.ViolationLevel" clearable
                                noDefault />
                        </v-col>
                        <v-col lg="2" md="3" cols="12">
                            <s-select-definition :def="1601" label="Estado" v-model="filter.State" clearable
                                noDefault />
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template slot-scope="props">
                <v-container fluid>
                    <v-row class="" dense>
                        <v-col lg="2" md="3" sm="6" cols="6" class="">
                            <s-date label="Fecha Infracción" v-model.lazy="item.ViolationDate" dense
                                hide-details></s-date>
                        </v-col>
                        <v-col lg="2" md="3" sm="6" cols="6" class="">
                            <s-text v-model="item.Code" type="number" label="Codigo" :maxlength="20" />
                        </v-col>
                        <v-col lg="3" md="3" sm="6" cols="6" class="">
                            <s-select-definition label="Tipo de Infracción" :def="1602" v-model="item.ViolationType"
                                clearable />
                        </v-col>
                        <v-col lg="2" md="3" sm="6" cols="6" class="">
                            <s-select-definition label="Nivel de Infracción" :def="1600" v-model="item.ViolationLevel"
                                clearable />
                        </v-col>
                        <v-col lg="3" md="6" sm="6" cols="12" class="">
                            <s-select-campaign-area label="Campaña" v-model="item.CmaID" clearable noDefault
                                typeArea="1"></s-select-campaign-area>
                        </v-col>

                        <v-col lg="4" md="6" sm="6" cols="12" class="" style="position: relative;">
                            <s-select v-model="driver" clearable autocomplete label="Conductor del vehículo"
                                :items="itemVehicles" item-text="DriverName" item-value="SpcID" return-object
                                @change="changevehicle" @returnObject="changevehicle"
                                placeholder="Seleccionar conductor" :slotTmp="true" id="spcvehicle" ref="spcvehicle">
                                <template #item="{ item }">
                                    <div style="display:flex; flex-direction:column;" class="py-1">
                                        <div class="font-weight-medium"
                                            style="max-width: 100%;text-wrap: pretty;text-wrap-mode: wrap;">
                                            <v-icon class="d-inline" color="dark"
                                                size="12">mdi-clipboard-account-outline</v-icon>
                                            {{ item.DriverName }} - {{ item.AdvDriverDNI }}
                                        </div>
                                        <div class="text--secondary text-caption">
                                            <v-icon class="d-inline" color="dark" size="12">mdi-car</v-icon>
                                            {{ item.TypeVehicleBrandName }} {{ item.TypeBrandText }} - {{
                                                item.VehPlate }}
                                        </div>
                                        <!-- <div class="text--secondary text-caption"
                                            style="max-width: 100%;text-wrap: pretty;text-wrap-mode: wrap;">
                                            <v-icon class="d-inline" color="dark" size="12">mdi-truck-check</v-icon>
                                            <span v-if="item.SpcID">
                                                {{ item.SpcCompanyName }} - {{ item.SpcDocument }}
                                            </span>
                                            <span class="red--text text-caption italic text-italic" v-else>
                                                NO SE ENCONTRÓ DATOS DEL TRANSPORTISTA
                                            </span>
                                        </div> -->
                                    </div>
                                </template>
                            </s-select>
                        </v-col>
                        <v-col lg="4" md="6" sm="6" cols="12" class="">
                            <s-text :value="driver.SpcID ? `${driver?.SpcCompanyName} - ${driver?.SpcDocument}` : ''"
                                label="Transportista" :disabled="true" />
                        </v-col>
                        <v-col lg="2" md="3" sm="6" cols="6" class="">
                            <s-text :value="driver.VehID ? `${driver?.VehPlate}` : ''" label="Placa" :disabled="true" />
                        </v-col>
                        <v-col lg="2" md="3" sm="6" cols="6" class="">
                            <s-text :value="driver.VehID ? `${driver.TypeVehicleBrandName}` : ''" label="Tipo Vehículo"
                                :disabled="true" />
                        </v-col>
                        <!-- <v-col lg="4" md="6" sm="6" cols="12" class="">
                            <s-text v-model="item.Description" label="Descripción de infracción" />
                        </v-col> -->
                        <v-col lg="4" md="6" sm="6" cols="12" class="">
                            <s-text v-model="item.Inspector" label="Inspector" />
                        </v-col>
                        <v-col lg="4" md="6" sm="6" cols="12" class="">
                            <s-text v-model="item.Location" label="Lugar de Infracción" />
                        </v-col>
                        <v-col lg="4" md="6" sm="6" cols="12" class="">
                            <s-text v-model="item.Sanction" label="Detalle de sanción aplicada" />
                        </v-col>
                        <v-col lg="2" md="3" sm="6" cols="12" class="">
                            <s-text v-model="item.Amount" type="number" label="Costo Sanción" />
                        </v-col>
                        <!-- <v-col lg="6" md="6" sm="6" cols="12" class="">
                            <s-text v-model="item.Observations" label="Detalles | Observaciones de sanción" />
                        </v-col> -->
                        <v-col lg="2" md="3" sm="6" cols="12" class="">
                            <s-select-definition label="Estado del Proceso" :def="1601" v-model="item.State"
                                clearable />
                        </v-col>

                        <v-col lg="3" md="4" sm="6" cols="12" class="">
                            <v-file-input label="Imágen de evidencia" id="EvidencePhoto" counter v-model="EvidencePhoto"
                                small-chips truncate-length="15" hide-details style="padding: 0px;"
                                :rules="[rulesFile('EvidencePhoto')]" accept="image/*" />
                        </v-col>
                        <v-col lg="3" md="4" sm="6" cols="12" class="">
                            <v-file-input label="Pdf del acta" id="DocumentPdf" counter v-model="DocumentPdf"
                                small-chips truncate-length="15" hide-details style="padding: 0px;"
                                :rules="[rulesFile('DocumentPdf')]" accept="application/pdf" />
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-slot:item.ViolationTypeName="{ item }">
                <div class="">
                    <v-chip x-small class="white--text px-1 rounded"
                        :color="item.ViolationLevel == 1 ? 'yellow' : (item.ViolationLevel == 2) ? 'orange' : 'red'">
                        {{ item.ViolationLevelName }}
                    </v-chip>
                    <br> {{ item.ViolationTypeName }}
                </div>
            </template>
            <template v-slot:item.SpcDocument="{ item }">
                {{ item.SpcCompanyName }} <br> {{ item.SpcDocument }}
            </template>
            <template v-slot:item.DriverName="{ item }">
                {{ item.DriverName }} <br> {{ item.AdvDriverDNI }}
            </template>

            <!-- <template v-slot:item.Description="{ item }">
                <div class="" style="min-width: 160px;">
                    <div>
                        <v-icon class="d-inline" color="primary" size="24">mdi-map-marker</v-icon>
                        {{ item.Location }}
                    </div>
                    <p class="ma-0 pa-0 text-caption text-uppercase">{{ item.Description }}</p>
                </div>
            </template> -->
            <template v-slot:item.Amount="{ item }">
                <span>{{ formatCurrency(item.Amount) }}</span>
            </template>

            <template v-slot:item.Sanction="{ item }">
                <div class="pa-0">
                    <p class="pa-0 ma-0">{{ item.Sanction }}</p>
                    <div class="d-flex align-center">
                        <v-icon class="mr-1" color="grey" size="12">mdi-map-marker</v-icon>
                        <span class="grey--text text-caption">{{ item.Location }}</span>
                    </div>
                </div>
            </template>
            <template v-slot:item.State="{ item }">
                <v-chip :color="getColor(item.State)" x-small outlined class="white--text px-2 rounded">
                    {{ item.StateName }}
                </v-chip>
            </template>
            <template v-slot:item.Options="{ item }">
                <v-tooltip v-if="item.EvidencePhoto" bottom="">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon color="success" @click="download(item.EvidencePhoto)"
                            title="Descargar Imágen">
                            <v-icon>mdi-image</v-icon>
                        </v-btn>
                    </template>
                    <span>Imágen</span>
                </v-tooltip>
                <v-tooltip v-if="item.DocumentPdf" bottom="">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon class="text-red red-darken-4" color="red"
                            @click="download(item.DocumentPdf)" title="Descargar PDF">
                            <v-icon>mdi-file-pdf-box</v-icon>
                        </v-btn>
                    </template>
                    <span>PDF</span>
                </v-tooltip>
            </template>
        </s-crud>
    </div>
</template>

<script>
import _SpcTrafficViolationService from "@/services/SupplyChain/TrafficViolation/SpcTrafficViolationService.js";
import _sDefinition from "@/services/General/DefinitionService.js";
import SSelectCarriers from "../../../components/Utils/SSelectCarriers.vue";
import _GenUploadFiles from "../../../services/General/GenUploadFiles";
import SSelectCampaignArea from "../../../components/Utils/SSelectCampaignArea.vue";


export default {
    components: { SSelectCarriers, SSelectCampaignArea },
    props: {
        close: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        filter: {
            Search: '',
            VehID: null,
            SpcID: null,
            State: 0,
            ViolationType: 0,
            ViolationLevel: 0,
            ViolationDate: '',
            ViolationHasta: '',
        },
        config: {
            model: {
                SpcID: "ID",
                SpcDocument: "string",
                SpcCompanyName: "string",
                Sanction: "string",
                SpcLocation: "string",
                ViolationDate: "date",
                SecCreate: "date",
                Options: ""
            },
            service: _SpcTrafficViolationService,
            headers: [
                // { text: "ID", value: "SpcID", width: 40, align: "center" },
                { text: "FECHA", value: "ViolationDate", align: "center" },
                { text: "CÓD.", value: "Code", width: 40, align: "center" },
                { text: "TIPO", value: "ViolationTypeName", align: "center" },
                { text: "PLACA", value: "VehPlate", align: "center" },
                { text: "PROVEEDOR", value: "SpcDocument", width: 200 },
                { text: "CONDUCTOR", value: "DriverName", width: 170 },
                { text: "LUGAR Y SANSIÓN APLICADA", value: "Sanction", width: 220 },
                // { text: "SANSIÓN APLICADA", value: "Sanction", width: 180 },
                { text: "MONTO", value: "Amount", width: 80, align: "center" },
                { text: "ESTADO", value: "State", align: "center" },
                // { text: "OBSERVACIONES", value: "Observations" },
                { text: "DOCUMENTOS", value: "Options" },
            ],
        },
        item: {
            TrvID: 0,
            Code: '',
            NtpID: null,
            VehID: null,
            SpcID: null,
            CmaID: null,
            ViolationLevel: 0,
            ViolationType: 0,
            Description: '',
            Location: '',
            ViolationDate: '',
            Inspector: '',
            Sanction: null,
            Amount: null,
            State: null,
            Observations: null,
            State: 0,
            SecStatus: 1,
            UsrCreateID: 0,
        },
        max_size: 3145728,
        EvidencePhoto: null,
        DocumentPdf: null,
        selected: [],
        itemVehicles: [],
        driver: {},
    }),
    methods: {
        rulesFile(propName) {
            return (value) => {
                if (!value || value == null || value == undefined || !value) {
                    this[propName] = null;
                    return true;
                }

                const formats_accepted = propName == "EvidencePhoto" ? ["image/jpeg", "image/jpg", "image/png"] : ["application/pdf"]

                if (!formats_accepted.includes(value.type)) {
                    this.$fun.alert(`Formato de archivo no permitido: ${value.type}`, "warning");
                    this[propName] = null;
                    return `Formato de archivo no permitido: ${value.type}`;
                }

                if (value.size > this.max_size) {
                    this.$fun.alert(`Tamaño de archivo excede el límite permitido: ${(this.max_size / 1024) / 1024}MB`);
                    this[propName] = null;
                    return `Tamaño de archivo excede el límite permitido: ${this.max_size}`;
                }

                return true; // ✅ Pasa la validación
            }
        },
        validateFile(type) {
            const file = this[type];
            if (file == null || file == undefined || !file) {
                this.$fun.alert("Seleccionar un archivo", "warning");
                return false
            }

            const formats_accepted = type == "EvidencePhoto" ? ["image/jpeg", "image/jpg", "image/png"] : ["application/pdf"]
            if (!formats_accepted.includes(file.type)) {
                this.$fun.alert("Formato de archivo no permitido (3MB)", "warning");
                return false;
            }
            if (file.size > this.max_size) {
                this.$fun.alert("Tamaño de archivo excede el límite permitido", "warning");
                return false;
            }
            return true;
        },
        async save() {
            if (this.item.ViolationDate == undefined || this.item.ViolationDate == "") {
                this.$fun.alert("Seleccionar fecha de infracción", "warning");
                return;
            }
            if (this.item.ViolationType == undefined || this.item.ViolationType == "") {
                this.$fun.alert("Seleccionar tipo de infracción", "warning");
                return;
            }
            if (this.item.ViolationLevel == undefined || this.item.ViolationLevel == "") {
                this.$fun.alert("Seleccionar nivel de infracción", "warning");
                return;
            }
            if (this.item.CmaID == undefined || this.item.CmaID == "") {
                this.$fun.alert("Seleccionar campaña", "warning");
                return;
            }
            if (this.item.NtpID == undefined || this.item.NtpID == "") {
                this.$fun.alert("Seleccionar conductor", "warning");
                return;
            }
            if (this.item.SpcID == undefined || this.item.SpcID == "") {
                this.$fun.alert("Datos del transportista no válido", "warning");
                return;
            }
            if (this.item.VehID == undefined || this.item.VehID == "") {
                this.$fun.alert("Datos del vehículo no válido", "warning");
                return;
            }
            // if (this.item.Description == undefined || this.item.Description == "") {
            //     this.$fun.alert("Ingresar descripción de infracción", "warning");
            //     return;
            // }

            if (this.item.Inspector == undefined || this.item.Inspector == "") {
                this.$fun.alert("Ingresar nombres del inspector o policía que registró la infracción", "warning");
                return;
            }
            if (this.item.Location == undefined || this.item.Location == "") {
                this.$fun.alert("Ingresar lugar de sanción", "warning");
                return;
            }
            if (this.item.Sanction == undefined || this.item.Sanction == "") {
                this.$fun.alert("Ingresar descripción de sanción aplicada", "warning");
                return;
            }
            if (this.item.Amount == undefined || Number(this.item.Amount) < 0) {
                this.$fun.alert("Ingresar monto de sanción", "warning");
                return;
            }
            if (this.item.State == undefined || this.item.State == "") {
                this.$fun.alert("Seleccionar estado del proceso", "warning");
                return;
            }

            let title = this.item.TrvID > 0 ? 'Actualizar ' : 'Agregar nuevo ';
            const result = await this.$fun.alert(`${title} registro?`, "question");

            if (result.value) {
                if (this.EvidencePhoto) {
                    const isValidImg = this.validateFile('EvidencePhoto')
                    if (isValidImg) {
                        const filename = `infra_pict_${Date.now()}`;
                        const respImg = await _GenUploadFiles.upload(this.EvidencePhoto, filename, 'PathTrafficViolation', true);
                        if (respImg.status !== 200) throw new Error(`Error al subir archivo en directorio.`);
                        this.item.EvidencePhoto = respImg.data.fileName;
                    }
                }

                if (this.DocumentPdf) {
                    const isValidPdf = this.validateFile('DocumentPdf')
                    if (isValidPdf) {
                        const filename = `infra_pdf_${Date.now()}`;
                        const respPdf = await _GenUploadFiles.upload(this.DocumentPdf, filename, 'PathTrafficViolation', true);
                        if (respPdf.status !== 200) throw new Error(`Error al subir archivo en directorio.`);
                        this.item.DocumentPdf = respPdf.data.fileName;
                    }
                }

                this.item.UsrCreateID = this.$fun.getUserID()
                _SpcTrafficViolationService.save(this.item, this.$fun.getUserID()).then(result => {
                    if (result.status == 200) {
                        let msg = this.item.TrvID > 0 ? 'Actualizado' : 'Registrado';
                        this.$fun.alert(msg + " correctamente", "success");
                        this.$emit('refresh', result.data);
                        this.$refs.crudtrafficviolations.refresh();
                        this.cleanFields();
                    }
                })
            }
        },
        rowSelected(item) {
            if (item && item.length > 0) {
                this.selected = item;
                this.item = { ...item[0] }
                this.driver = {
                    SpcID: this.item.SpcID,
                    NtpID: this.item.NtpID,
                    VehID: this.item.VehID,
                    SpcCompanyName: this.item.SpcCompanyName,
                    SpcDocument: this.item.SpcDocument,
                    TypeVehicleText: this.item.TypeVehicleText,
                    TypeBrandText: this.item.TypeBrandText,
                    TypeColorText: this.item.TypeColorText,
                    VehPlate: this.item.VehPlate
                }
                this.changevehicle(this.driver);
                // console.log(this.item)
            }
        },
        cleanFields() {
            this.driver = {};
            this.EvidencePhoto = null
            this.DocumentPdf = null
            this.item = {
                TrvID: 0,
                Code: '',
                NtpID: null,
                VehID: null,
                SpcID: null,
                CmaID: null,
                ViolationLevel: 0,
                ViolationType: 0,
                Description: '',
                Location: '',
                ViolationDate: '',
                Inspector: '',
                Sanction: null,
                Amount: null,
                State: 0,
                Observations: null,
                State: null,
                SecStatus: 1,
                UsrCreateID: 0,
            }
        },
        changevehicle: function (item) {
            this.driver = item ? { ...item } : {}
            this.item.SpcID = item ? item.SpcID : null
            this.item.NtpID = item ? item.NtpID : null
            this.item.VehID = item ? item.VehID : null
            // console.log(item);
        },
        filtervehicle(value) {
            console.log(value);
        },
        loadVehicles() {
            _SpcTrafficViolationService.vehicleslist({ SpcID: this.item.SpcID }, this.$fun.getUserID()).then(result => {
                if (result.status == 200) {
                    // console.log(result.data);
                    this.itemVehicles = result.data;
                }
            })
        },
        download(fileName) {
            console.log(`Descargando archivo : ${fileName}`)
            if (fileName) {
                _GenUploadFiles.getFile("PathTrafficViolation", `${fileName}`)
                    .then(resp => console.log('downloaded : ', resp))
                    .catch(error => console.error("Error al obtener archivo:", error));
            }
        },
        getColor(value) {
            let color = ''
            switch (value) {
                case 1: color = 'orange'; break
                case 2: color = 'green'; break
                case 3: color = 'primary'; break
                case 4: color = 'green'; break
                default: color = 'red'; break
            }
            return color
        },
        formatCurrency(value) {
            if (value === null || value === undefined) return ''
            return new Intl.NumberFormat('es-PE', {
                style: 'currency',
                currency: 'PEN',
                minimumFractionDigits: 2
            }).format(value)
        }
    },
    watch: {
        // dialogFiles(value) {
        //     if (!value) {
        //         this.$refs.crudtrafficviolations.refresh();
        //     }
        // },
    },
    mounted() {
        this.loadVehicles();
    }
};
</script>

<style scoped>
.gradient-primary {
    background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-content {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.header-left {
    width: 100%;
    display: flex;
    gap: 8px;
    align-items: center;
    flex: 1 1 0%;
}

.header-right {
    display: flex;
    justify-items: center;
    align-items: center !important;
    min-width: 300px;
}

.search-field-header {
    padding: 2px;
    align-items: center !important;
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 1rem;
    max-width: 250px;
}

.search-field-header>>>.v-input__slot {
    background-color: rgba(255, 255, 255, 0.15) !important;
}

@media (max-width:768px) {
    .header-content {
        flex-direction: column;
    }

    .search-field-header {
        width: 100%;
        max-width: 80%;
    }
}
</style>
